import type { Organization } from '@eppendorf/vnls-user-tenant-utils';

export function displayOrganization(organization?: Organization): string {
  return `${organization?.name}`;
}
